import React from 'react';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import './DetalleEvaluacionModal.css';

const DetalleEvaluacionModal = ({ usuario, evaluacion, onCerrar }) => {
  const getNivelLiderazgo = (puntuacion) => {
    if (puntuacion <= 20) return 'Liderazgo en desarrollo';
    if (puntuacion <= 40) return 'Liderazgo intermedio';
    if (puntuacion <= 50) return 'Liderazgo avanzado';
    if (puntuacion <= 80) return 'Liderazgo experto';
    return 'Liderazgo transformacional';
  };

  const descargarPDF = async () => {
    const elemento = document.getElementById('detalle-evaluacion-contenido');
    
    const canvas = await html2canvas(elemento, {
      scale: 2,
      logging: false,
      useCORS: true,
      backgroundColor: '#ffffff',
      windowWidth: 1200,
      width: 900,
      // Usar onclone para forzar estilos de escritorio en el clon
      onclone: (clonedDoc) => {
        const clonedElement = clonedDoc.getElementById('detalle-evaluacion-contenido');
        if (clonedElement) {
          // Forzar ancho de escritorio
          clonedElement.style.width = '900px';
          clonedElement.style.minWidth = '900px';
          clonedElement.style.maxWidth = '900px';
          clonedElement.classList.add('pdf-desktop-mode');
          
          // Ocultar botones en el clon
          const btnCerrar = clonedDoc.querySelector('.modal-detalle-cerrar');
          const btnDescargar = clonedDoc.querySelector('.modal-btn-descargar');
          if (btnCerrar) btnCerrar.style.display = 'none';
          if (btnDescargar) btnDescargar.style.display = 'none';
          
          // Forzar estilos de escritorio directamente en los elementos clonados
          clonedElement.style.padding = '40px 32px 24px';
          
          const headerH2 = clonedElement.querySelector('.detalle-header h2');
          if (headerH2) {
            headerH2.style.fontSize = '26px';
          }
          
          const fecha = clonedElement.querySelector('.detalle-fecha');
          if (fecha) {
            fecha.style.fontSize = '12px';
          }
          
          const usuarioH3 = clonedElement.querySelector('.detalle-usuario-info h3');
          if (usuarioH3) {
            usuarioH3.style.fontSize = '20px';
          }
          
          const puntuacionGrande = clonedElement.querySelector('.puntuacion-grande');
          if (puntuacionGrande) {
            puntuacionGrande.style.fontSize = '40px';
          }
          
          const competenciasH4 = clonedElement.querySelector('.detalle-competencias h4');
          if (competenciasH4) {
            competenciasH4.style.fontSize = '18px';
          }
          
          const competenciasGrid = clonedElement.querySelector('.competencias-grid-detalle');
          if (competenciasGrid) {
            competenciasGrid.style.cssText = `
              display: grid !important;
              grid-template-columns: repeat(3, 1fr) !important;
              gap: 16px !important;
            `;
          }
          
          // Forzar estilos en cada competencia
          const competencias = clonedElement.querySelectorAll('.competencia-detalle');
          competencias.forEach(comp => {
            comp.style.padding = '16px';
          });
          
          const compNombres = clonedElement.querySelectorAll('.comp-nombre');
          compNombres.forEach(nombre => {
            nombre.style.fontSize = '13px';
          });
          
          const compValores = clonedElement.querySelectorAll('.comp-valor-grande');
          compValores.forEach(valor => {
            valor.style.fontSize = '24px';
          });
        }
      }
    });

    const imgData = canvas.toDataURL('image/png');
    const pdf = new jsPDF({
      orientation: 'landscape',
      unit: 'px',
      format: [canvas.width, canvas.height]
    });

    pdf.addImage(imgData, 'PNG', 0, 0, canvas.width, canvas.height);
    pdf.save(`Evaluacion_${usuario}_${new Date().toLocaleDateString()}.pdf`);
  };

  // Las inconclusas (vistas desde el panel admin) no tienen puntuación todavía.
  const completada = evaluacion.completada !== false && evaluacion.puntuacion_total != null;
  const nivel = completada ? getNivelLiderazgo(evaluacion.puntuacion_total) : 'Evaluación inconclusa';

  return (
    <div className="modal-detalle-overlay" onClick={onCerrar}>
      <div className="modal-detalle-container" onClick={(e) => e.stopPropagation()}>
        <button className="modal-detalle-cerrar" onClick={onCerrar}>×</button>
        
        <div id="detalle-evaluacion-contenido" className="detalle-evaluacion-contenido">
          <div className="detalle-header">
            <h2>Evaluación de Liderazgo</h2>
            <p className="detalle-fecha">
              {new Date(evaluacion.fecha_evaluacion).toLocaleDateString('es-ES', {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
              })}
            </p>
          </div>

          <div className="detalle-usuario-info">
            <h3>{usuario}</h3>
            <div className="detalle-nivel">
              <span className="nivel-label">Nivel de Liderazgo:</span>
              <span className="nivel-badge">{nivel}</span>
            </div>
          </div>

          <div className="detalle-puntuacion-principal">
            <span className="puntuacion-label">Puntuación Total</span>
            <span className="puntuacion-grande">{completada ? Math.round(evaluacion.puntuacion_total) : '–'}</span>
          </div>

          <div className="detalle-competencias">
            <h4>Competencias Evaluadas</h4>
            <div className="competencias-grid-detalle">
              <div className="competencia-detalle">
                <div className="comp-header">
                  <span className="comp-nombre">Innovación</span>
                  <span className="comp-codigo">(In)</span>
                </div>
                <div className="comp-valor-grande">{evaluacion.innovacion ?? '–'}/5</div>
                <div className="comp-barra-detalle">
                  <div className="comp-fill-detalle" style={{ width: `${(evaluacion.innovacion / 5) * 100}%` }}></div>
                </div>
              </div>

              <div className="competencia-detalle">
                <div className="comp-header">
                  <span className="comp-nombre">Inteligencia Emocional</span>
                  <span className="comp-codigo">(EQ)</span>
                </div>
                <div className="comp-valor-grande">{evaluacion.inteligencia_emocional ?? '–'}/5</div>
                <div className="comp-barra-detalle">
                  <div className="comp-fill-detalle" style={{ width: `${(evaluacion.inteligencia_emocional / 5) * 100}%` }}></div>
                </div>
              </div>

              <div className="competencia-detalle">
                <div className="comp-header">
                  <span className="comp-nombre">Humor</span>
                  <span className="comp-codigo">(H)</span>
                </div>
                <div className="comp-valor-grande">{evaluacion.humor ?? '–'}/5</div>
                <div className="comp-barra-detalle">
                  <div className="comp-fill-detalle" style={{ width: `${(evaluacion.humor / 5) * 100}%` }}></div>
                </div>
              </div>

              <div className="competencia-detalle">
                <div className="comp-header">
                  <span className="comp-nombre">Ego</span>
                  <span className="comp-codigo">(Eg)</span>
                </div>
                <div className="comp-valor-grande">{evaluacion.ego ?? '–'}/5</div>
                <div className="comp-barra-detalle">
                  <div className="comp-fill-detalle" style={{ width: `${(evaluacion.ego / 5) * 100}%` }}></div>
                </div>
              </div>

              <div className="competencia-detalle">
                <div className="comp-header">
                  <span className="comp-nombre">Propósito</span>
                  <span className="comp-codigo">(Pr)</span>
                </div>
                <div className="comp-valor-grande">{evaluacion.proposito ?? '–'}/5</div>
                <div className="comp-barra-detalle">
                  <div className="comp-fill-detalle" style={{ width: `${(evaluacion.proposito / 5) * 100}%` }}></div>
                </div>
              </div>

              <div className="competencia-detalle">
                <div className="comp-header">
                  <span className="comp-nombre">Adaptabilidad</span>
                  <span className="comp-codigo">(Adp)</span>
                </div>
                <div className="comp-valor-grande">{evaluacion.adaptabilidad ?? '–'}/5</div>
                <div className="comp-barra-detalle">
                  <div className="comp-fill-detalle" style={{ width: `${(evaluacion.adaptabilidad / 5) * 100}%` }}></div>
                </div>
              </div>

              <div className="competencia-detalle">
                <div className="comp-header">
                  <span className="comp-nombre">Empatía</span>
                  <span className="comp-codigo">(E)</span>
                </div>
                <div className="comp-valor-grande">{evaluacion.empatia ?? '–'}/5</div>
                <div className="comp-barra-detalle">
                  <div className="comp-fill-detalle" style={{ width: `${(evaluacion.empatia / 5) * 100}%` }}></div>
                </div>
              </div>

              <div className="competencia-detalle">
                <div className="comp-header">
                  <span className="comp-nombre">Motivación</span>
                  <span className="comp-codigo">(M)</span>
                </div>
                <div className="comp-valor-grande">{evaluacion.motivacion ?? '–'}/5</div>
                <div className="comp-barra-detalle">
                  <div className="comp-fill-detalle" style={{ width: `${(evaluacion.motivacion / 5) * 100}%` }}></div>
                </div>
              </div>

              <div className="competencia-detalle">
                <div className="comp-header">
                  <span className="comp-nombre">Negociación</span>
                  <span className="comp-codigo">(N)</span>
                </div>
                <div className="comp-valor-grande">{evaluacion.negociacion ?? '–'}/5</div>
                <div className="comp-barra-detalle">
                  <div className="comp-fill-detalle" style={{ width: `${(evaluacion.negociacion / 5) * 100}%` }}></div>
                </div>
              </div>

              <div className="competencia-detalle">
                <div className="comp-header">
                  <span className="comp-nombre">Trabajo en Equipo</span>
                  <span className="comp-codigo">(T)</span>
                </div>
                <div className="comp-valor-grande">{evaluacion.trabajo_equipo ?? '–'}/5</div>
                <div className="comp-barra-detalle">
                  <div className="comp-fill-detalle" style={{ width: `${(evaluacion.trabajo_equipo / 5) * 100}%` }}></div>
                </div>
              </div>

              <div className="competencia-detalle">
                <div className="comp-header">
                  <span className="comp-nombre">Factor de Contexto</span>
                  <span className="comp-codigo">(F)</span>
                </div>
                <div className="comp-valor-grande">{evaluacion.factor_contexto ?? '–'}/5</div>
                <div className="comp-barra-detalle">
                  <div className="comp-fill-detalle" style={{ width: `${(evaluacion.factor_contexto / 5) * 100}%` }}></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="modal-acciones-detalle">
          <button className="modal-btn-cerrar-detalle" onClick={onCerrar}>
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
};

export default DetalleEvaluacionModal;

